import {
  CREATE_USER_IF_NOT_EXIST
} from './constants';
import {makeCall} from '../../../utils/request';
import {buildOptions, getEndPoint} from '../../../utils/api-call';

export const state = {};

export const actions = {
  [CREATE_USER_IF_NOT_EXIST] ({ commit }, body, options) {
    return new Promise((resolve, reject) => {
      makeCall(getEndPoint().oauth2.createUserIfNotExist, buildOptions('POST', body, null, options))
        .then(response => {
          return resolve(response);
        }).catch(error => {
          return reject(error);
        });
    });
  }
};

export const getters = {};

export const mutations = {
};

export default {
  state,
  actions,
  getters,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/oauth2/index.js